import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { openLoginSignupModal } from '../user/currentUserActions';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import flagUk from '../assets/icons/flag-uk.svg';
import flagEt from '../assets/icons/flag-et.svg';

const NavbarXs = ({ isXsNavOpen, openLoginSignupModal, currentUser, logout, setLanguage }) => {
  const classes = classNames({
    'navbar-xs d-block d-lg-none': true,
    'm-visible': isXsNavOpen,
  });

  const isMarketplaceOwner = currentUser && currentUser.authorities.indexOf('ROLE_MARKETPLACE_CREATOR') !== -1;
  const isAdmin = currentUser && currentUser.authorities.indexOf('ROLE_ADMIN') !== -1;
  const isAccountant = currentUser && currentUser.authorities.indexOf('ROLE_ACCOUNTANT') !== -1;
  const isPacker = currentUser && currentUser.authorities.indexOf('ROLE_PACKER') !== -1;
  const isLogistic = currentUser && currentUser.authorities.indexOf('ROLE_LOGISTICS') !== -1;

  return (
    <div className={classes}>
      <div className="navbar-xs__links">
        <ul className="list-unstyled">
          <li className="navbar-xs__links-link m-flag">
            <button className="btn btn-link btn-normal-link" onClick={() => setLanguage('en')}>
              <img src={flagUk} alt="UK flag for translation" />
            </button>
          </li>
          <li className="navbar-xs__links-link m-flag">
            <button className="btn btn-link btn-normal-link" onClick={() => setLanguage('et')}>
              <img src={flagEt} alt="Estonian flag for translation" />
            </button>
          </li>
          <li className="navbar-xs__links-link">
            <a
              href="https://healthy-promotion-e73.notion.site/Oluline-info-tootjatele-42b69b0253624d39bd148b3545820ed3"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FormattedMessage id={'navbar.links.info'} />
            </a>
          </li>

          {isAdmin ? (
            <li className="navbar-xs__links-link">
              <NavLink activeClassName="active" to="/admin">
                <FormattedMessage id={'navbar.links.admin'} />
              </NavLink>
            </li>
          ) : (
            ''
          )}
          {isAccountant ? (
            <>
              <li className="navbar-xs__links-link">
                <NavLink activeClassName="active" to="/admin/bills">
                  <FormattedMessage id={'navbar.links.accountant.bills'} />
                </NavLink>
              </li>
              <li className="navbar-xs__links-link">
                <NavLink activeClassName="active" to="/admin/payoutReports">
                  <FormattedMessage id={'navbar.links.accountant.payout.reports'} />
                </NavLink>
              </li>
              <li className="navbar-xs__links-link">
                <NavLink activeClassName="active" to="/admin/combinedOrderItems">
                  <FormattedMessage id={'navbar.links.accountant.combined.order.items'} />
                </NavLink>
              </li>
            </>
          ) : (
            ''
          )}
          {isMarketplaceOwner || isAdmin ? (
            <li className="navbar-xs__links-link">
              <NavLink activeClassName="active" to="/shops">
                <FormattedMessage id={'navbar.links.shops'} />
              </NavLink>
            </li>
          ) : (
            ''
          )}
          {isPacker ? (
            <li className="navbar-xs__links-link">
              <NavLink activeClassName="active" to="/admin/packing/deliveryDays">
                <FormattedMessage id={'navbar.links.packer.delivery.days'} />
              </NavLink>
            </li>
          ) : (
            ''
          )}
          {isLogistic ? (
            <>
              <li className="navbar-xs__links-link">
                <NavLink activeClassName="active" to="/admin/routePlanning">
                  <FormattedMessage id={'navbar.links.packer.route.optimisation'} />
                </NavLink>
              </li>
              <li className="navbar-xs__links-link">
                <NavLink activeClassName="active" to="/admin/routePlanningV2">
                  <FormattedMessage id={'navbar.links.packer.route.optimisation.v2'} />
                </NavLink>
              </li>
            </>
          ) : (
            ''
          )}

          {currentUser ? (
            <>
              <li className="navbar-xs__links-link">
                <NavLink activeClassName="active" to="/edit-profile">
                  <FormattedMessage id={'navbar.links.edit.profile'} />
                </NavLink>
              </li>
              <li className="navbar-xs__links-link">
                <a href="#" onClick={logout}>
                  <FormattedMessage id={'navbar.links.log.out'} />
                </a>
              </li>
            </>
          ) : (
            <>
              <li className="navbar-xs__links-link">
                <a href="#" onClick={() => openLoginSignupModal('login')}>
                  <FormattedMessage id={'navbar.links.log.in'} />
                </a>
              </li>
              <li className="navbar-xs__links-link">
                <button className="btn btn-small btn-primary" onClick={() => openLoginSignupModal('signup')}>
                  <FormattedMessage id={'navbar.links.sign.up'} />
                </button>
              </li>
            </>
          )}
        </ul>
      </div>
    </div>
  );
};

NavbarXs.propTypes = {
  isXsNavOpen: PropTypes.bool,
  logout: PropTypes.func.isRequired,
};

NavbarXs.defaultProps = {
  isXsNavOpen: false,
};

const mapDispatchToProps = {
  openLoginSignupModal,
};

function mapStateToProps(state) {
  return {
    currentUser: state.currentUser.user,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(NavbarXs);
